import { IFormArr } from '@/components/types'

export const basicFormConfig: IFormArr = {
  iForms: [
    {
      formItems: [
        {
          label: '客户分类',
          field: 'custType',
          type: 'select',
          placeholder: '请选择客户分类',
          clearable: true,
          options: [
            { title: 'A类', value: '0' },
            { title: 'B类', value: '1' },
            { title: 'C类', value: '2' },
            { title: 'D类', value: '3' }
          ]
        },
        {
          label: '开发账号',
          field: 'exploitAccount',
          type: 'input',
          maxLength: 40,
          placeholder: '请输入开发账号'
        },
        {
          label: '客户昵称',
          field: 'custName',
          type: 'input',
          maxLength: 40,
          placeholder: '请输入客户昵称/名字'
        }
      ]
    },
    {
      formItems: [
        {
          label: '资金量',
          field: 'funds',
          type: 'number',
          maxLength: 9,
          placeholder: '请输入资金量',
          suffix: '万'
        },
        {
          label: '年龄段',
          type: 'select',
          field: 'ageGroup',
          placeholder: '请选择年龄段',
          clearable: true,
          options: [
            { title: '20-34', value: '0' },
            { title: '35-49', value: '1' },
            { title: '50-64', value: '2' },
            { title: '65-79', value: '3' },
            { title: '≥80', value: '4' }
          ]
        },
        {
          label: '股龄',
          field: 'stockAge',
          type: 'input',
          maxLength: 20,
          placeholder: '请输入股龄'
        }
      ]
    },
    {
      formItems: [
        {
          label: '盈亏情况',
          field: 'profitAndLoss',
          type: 'input',
          maxLength: 300,
          placeholder: '请输入盈亏情况'
        },
        {
          label: '金融投资经历',
          field: 'financialInvestment',
          type: 'select',
          placeholder: '请选择金融投资经历',
          suffix: '种',
          clearable: true,
          options: [
            { title: '无', value: '0' },
            { title: '1', value: '1' },
            { title: '2', value: '2' },
            { title: '≥3', value: '3' }
          ]
        },
        {
          label: '职业',
          field: 'job',
          type: 'input',
          maxLength: 20,
          placeholder: '请输入职业'
        }
      ]
    },
    {
      formItems: [
        {
          label: '地域',
          field: 'zone',
          type: 'input',
          maxLength: 50,
          placeholder: '请输入地域'
        },
        {
          label: '签约经历',
          type: 'select',
          field: 'signExperience',
          placeholder: '请选择签约经历',
          clearable: true,
          options: [
            { title: '无', value: '0' },
            { title: '有', value: '1' }
          ]
        },
        {
          label: '签约情况',
          field: 'signStatus',
          type: 'textarea',
          maxLength: 300,
          placeholder: '请输入签约情况'
        }
      ]
    },
    {
      formItems: [
        {
          label: '操作风格',
          type: 'select',
          field: 'operateStyle',
          placeholder: '请选择操作风格',
          clearable: true,
          options: [
            { title: '短线', value: '0' },
            { title: '中线', value: '1' },
            { title: '长线', value: '2' }
          ]
        },
        {
          label: '空闲时间',
          field: 'freeTime',
          type: 'textarea',
          maxLength: 300,
          placeholder: '请输入空闲时间'
        },
        {
          label: '预计成交时间',
          field: 'estimatedTxTime',
          type: 'datepicker',
          placeholder: '请选择预计成交时间',
          otherOptions: {
            'value-format': 'YYYY-MM-DD'
          }
        }
      ]
    },
    {
      formItems: [
        {
          label: '报价金额/版本',
          field: 'amountQuoted',
          type: 'textarea',
          maxLength: 300,
          placeholder: '请输入报价金额/版本'
        },
        {
          label: '员工',
          field: 'empName',
          type: 'default'
        },
        {
          label: '生活工作细节点',
          field: 'lifeAndWork',
          type: 'textarea',
          maxLength: 500,
          placeholder: '请输入生活工作细节点'
        }
      ]
    },
    {
      formItems: [
        {
          label: '今日跟踪情况',
          field: 'todayTrackCondition',
          type: 'textarea',
          maxLength: 300,
          placeholder: '请输入今日跟踪情况'
        },
        {
          label: '明日跟踪标准',
          field: 'tmrTrackPlan',
          type: 'textarea',
          maxLength: 300,
          placeholder: '请输入明日跟踪标准'
        },
        {
          label: '操作痛点和抗拒点',
          field: 'painAndResist',
          type: 'textarea',
          maxLength: 500,
          placeholder: '请输入操作痛点和抗拒点'
        }
      ]
    }
  ]
}
